import React from 'react';
import { List } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../../../utils/queries'

import TitDer from '../../../components/funcionales/titder';

const Detalle = ({elemento, handleClickidLista}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPrueba}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrAplicacion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.valor1Alarma}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.valor2Alarma}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.valor3Alarma}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.valor1Corte}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.valor2Corte}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.valor3Corte}</td>
    </tr>
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, i) => <Detalle elemento={elemento}
        handleClickidLista={handleClickidLista}
        key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

// const LabPruebaLab2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
class LabPruebaLab2 extends React.Component {
  state={argsBuscEstruct: {}, 
  argsQuery: `{"$unwind": "$pruebaslab"},
  {$project: {_id: '$pruebaslab.fechaCreate', tipoPrueba: 1, descrPrueba: 1, validacion: 1,
      descrAplicacion: '$pruebaslab.descrAplicacion', 
      valor1Alarma: '$pruebaslab.valor1Alarma', 
      valor2Alarma: '$pruebaslab.valor2Alarma', 
      valor3Alarma: '$pruebaslab.valor3Alarma', 
      valor1Corte: '$pruebaslab.valor1Corte', 
      valor2Corte: '$pruebaslab.valor2Corte', 
      valor3Corte: '$pruebaslab.valor3Corte',
      fechaCreate: '$pruebaslab.fechaCreate'}},
  {$sort: {tipoPrueba: 1, descrPrueba: 1, descrAplicacion: 1}}`
  }

  componentDidMount(){
    this.props.allPruebaRtes.refetch()
  }

  componentDidUpdate(prevProps){
    // console.log(this.props.argsBuscPruebaLab, this.state.argsBuscPruebaLab)
    if(this.props.allPruebaRtes.allPruebaRtes!==prevProps.allPruebaRtes){
      this.props.allPruebaRtes.refetch()
    }
    if(this.props.argsBuscPruebaLab!==this.state.argsBuscPruebaLab){
      let argsBuscar=""
      if(this.props.argsBuscPruebaLab.descrPrueba){
        argsBuscar += `'descrPrueba': /${this.props.argsBuscPruebaLab.descrPrueba}/i`
      }
      if(this.props.argsBuscPruebaLab.descrAplicacion){
        if(argsBuscar){argsBuscar += `, `}
        argsBuscar += `'descrAplicacion': /${this.props.argsBuscPruebaLab.descrAplicacion}/i`
      }
      let argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
      this.props.allPruebaRtes.refetch(argsBuscarPl)

      this.setState({argsBuscPruebaLab: this.props.argsBuscPruebaLab})
    }
  }

  render(){
    // console.log(this.props.argsBuscPruebaLab)
    const a100501 = this.props.autorizacUA.findIndex( autorizac => autorizac === "100501" );
    let list=[]
    if (this.props.allPruebaRtes.allPruebaRtes){
      list=this.props.allPruebaRtes.allPruebaRtes
    }
// console.log(list)
    return (
    <div>
      <List selection>
      <TitDer list={this.props.list} textBoton1="Valores de referencia" btnNuevo={a100501!==-1?"SI":"NO"} styles={this.props.styles} handleClick={this.props.handleClick} />

      <div>
        <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
          <thead className=''>
            <tr className=''>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Prueba</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Aplicación</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Valor 1 alarma</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Valor 2 alarma</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Valor 3 alarma</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Valor 1 corte</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Valor 2 corte</th>
              <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Valor 3 corte</th>
              </tr>
          </thead>
          <Lista list={list} handleClickidLista={this.props.handleClickidLista}/>
        </table>
        <p></p>
      </div>
      </List>
    </div>
  )
  }
};

export default compose(
  graphql(queries.query.allPruebaRtes, {name:'allPruebaRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'tipoPrueba': {$ne: 'Pruebas especiales'}}},
      {"$unwind": "$pruebaslab"},
      {$project: {_id: '$pruebaslab.fechaCreate', tipoPrueba: 1, descrPrueba: 1, validacion: 1,
          descrAplicacion: '$pruebaslab.descrAplicacion', 
          valor1Alarma: '$pruebaslab.valor1Alarma', 
          valor2Alarma: '$pruebaslab.valor2Alarma', 
          valor3Alarma: '$pruebaslab.valor3Alarma', 
          valor1Corte: '$pruebaslab.valor1Corte', 
          valor2Corte: '$pruebaslab.valor2Corte', 
          valor3Corte: '$pruebaslab.valor3Corte',
          fechaCreate: '$pruebaslab.fechaCreate'}},
      {$sort: {tipoPrueba: 1, descrPrueba: 1}}, 
  ]`}}}}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(LabPruebaLab2)